import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
  FormFeedback,
  Button, // Import FormFeedback for error messages
} from "reactstrap";
import * as Yup from "yup"; // Import Yup for validation
import { useFormik } from "formik";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import MediaModal from "../../../Kangaroo/PagesSection/Component/MediaModal";
import WidgetService from "../../../services/KangarooServices/Intelligence/WidgetService";
import { imageBaseApi } from "../../../utilis/imageHelper";

const WidgetForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [detailData, setDetailData] = useState({});
  const [isMediaOpen, setIsMediaOpen] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);

  const toggleMedia = () => setIsMediaOpen(!isMediaOpen);
  const fetchPageDetail = async () => {
    try {
      const response = await WidgetService.getdetail(id);
      setDetailData(response);

      setSelectedMedia(response.image);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (id) fetchPageDetail();
  }, [id]);

  const formik = useFormik({
    initialValues: {
      id: detailData?.id || "",

      type: detailData?.type || "",
      name: detailData?.name || "",
      description: detailData?.description || "",
      imageId: detailData?.imageId || "",
      image: detailData?.image?.url,
      headingName: detailData?.headingName,
    },
    enableReinitialize: true,

    onSubmit: async (values) => {
      try {
        // Build payload
        const payload = {
          name: values.name,
          description: values.description,
          imageId: selectedMedia?.id || null,
        //   type: values?.type,
          headingName: values?.headingName,
        };

        if (values?.id) {
          await WidgetService.update(values?.id, payload);
          toast.success("Widget updated successfully");
        } else {
          await WidgetService.create(payload);
          toast.success("Widget created successfully");
        }

        navigate(`/widgets`);
      } catch (error) {
        console.log(error);
        toast.error("Something went wrong!");
      }
    },
  });

  const breadcrumbItems = [{ title: "Back to List", link: "/widgets" }];
  const PageTypeEnum = {
    SingleText: 1,
    ParagraphText: 2,
    List: 3,
    Image: 4,
  };
  const pageTypeOptions = Object.entries(PageTypeEnum).map(
    ([label, value]) => ({
      label,
      value,
    }),
  );

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb
          title="Widget Form"
          pageTitle="Widgets"
          breadcrumbItems={breadcrumbItems}
        />

        <form onSubmit={formik.handleSubmit}>
          <div className="d-flex justify-content-end gap-3 mb-3">
            <button type="submit" className="btn btn-success">
              {id ? "Update" : "Create"}
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => navigate("/widgets")}
            >
              Cancel
            </button>
          </div>

          <Row>
            <Col lg={8}>
              <Card>
                <CardBody>
                  {/* Title Field */}

                  {/* Subtitle Field */}
                  <FormGroup className="mb-3">
                    <Label htmlFor="name">Name</Label>
                    <Input
                      id="name"
                      name="name"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      invalid={formik.touched.name && !!formik.errors.name}
                    />
                    {formik.touched.name && formik.errors.name && (
                      <FormFeedback>{formik.errors.name}</FormFeedback>
                    )}
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <Label htmlFor="name">Sub Heading</Label>
                    <Input
                      id="headingName"
                      name="headingName"
                      value={formik.values.headingName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      invalid={
                        formik.touched.headingName &&
                        !!formik.errors.headingName
                      }
                    />
                    {formik.touched.headingName &&
                      formik.errors.headingName && (
                        <FormFeedback>{formik.errors.headingName}</FormFeedback>
                      )}
                  </FormGroup>

                  {/* Content Field (CKEditor) */}
                  <FormGroup className="mb-3">
                    <Label>
                      Description <span className="text-danger">*</span>
                    </Label>
                    <CKEditor
                      editor={ClassicEditor}
                      data={formik.values.description}
                      onChange={(event, editor) =>
                        formik.setFieldValue("description", editor.getData())
                      }
                      onBlur={() => formik.setFieldTouched("description", true)} // Manual touch for validation
                    />
                    {/* Custom error display for CKEditor description */}
                    {formik.touched.description &&
                      formik.errors.description && (
                        <div
                          className="text-danger mt-1"
                          style={{ fontSize: "0.875em" }}
                        >
                          {formik.errors.description}
                        </div>
                      )}
                  </FormGroup>

                  {/* <div className="mb-3">
                    <Label>Type</Label>
                    <Select
                      options={pageTypeOptions}
                      name="type"
                      value={
                        pageTypeOptions.find(
                          (option) => option.value === formik.values.type,
                        ) || null
                      }
                      onChange={(selectedOption) =>
                        formik.setFieldValue(
                          "type",
                          selectedOption ? selectedOption.value : "",
                        )
                      }
                      placeholder="Select Type"
                    />
                  </div> */}
                </CardBody>
              </Card>
            </Col>

            <Col lg={4}>
              <Card>
                <CardBody>
                  <Label style={{ cursor: "pointer" }}>Featured Media</Label>
                  {selectedMedia ? (
                    <div className="text-center p-3 border rounded shadow-sm bg-light">
                      {/* Image Preview */}
                      <div
                        style={{
                          maxHeight: "220px",
                          overflow: "hidden",
                          borderRadius: "10px",
                          border: "1px solid #ddd",
                        }}
                        className="mb-3"
                      >
                        <img
                          src={`${imageBaseApi}${selectedMedia?.url}`}
                          alt="Featured"
                          style={{ width: "100%", objectFit: "cover" }}
                          className="img-fluid hover-zoom"
                        />
                      </div>

                      {/* Image Info */}
                      <div className="mb-2">
                        <div className="fw-semibold">
                          {selectedMedia.name || "Featured Image"}
                        </div>

                        {selectedMedia.size && (
                          <small className="text-muted">
                            Size: {(selectedMedia.size / 1024).toFixed(1)} KB
                          </small>
                        )}
                      </div>

                      {/* Buttons */}
                      <div className="d-flex gap-2 justify-content-center">
                        <Button
                          size="sm"
                          outline
                          color="primary"
                          className="rounded-pill px-3"
                          onClick={toggleMedia}
                        >
                          Change
                        </Button>

                        <Button
                          size="sm"
                          outline
                          color="danger"
                          className="rounded-pill px-3"
                          onClick={() => {
                            // formik.setFieldValue("imageId", "");
                            setSelectedMedia(null);
                            formik.setFieldValue("image", null);
                          }}
                        >
                          <i className="ri-delete-bin-5-line me-1"></i>
                          Remove
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <div className="p-4 border rounded text-center bg-light">
                      <i className="ri-image-add-line fs-1 text-secondary"></i>
                      <h6 className="mt-2 mb-2 text-muted">
                        No image selected
                      </h6>
                      <h6 className="mb-3 text-muted">1200 x 630</h6>
                      <Button
                        outline
                        color="secondary"
                        className="rounded-pill px-4"
                        onClick={toggleMedia}
                      >
                        <i className="ri-image-add-line me-1"></i> Choose
                        Featured Image
                      </Button>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </form>
      </div>

      <MediaModal
        isOpen={isMediaOpen}
        toggle={toggleMedia}
        selectedMedia={selectedMedia}
        setSelectedMedia={setSelectedMedia}
      />
    </Container>
  );
};

export default WidgetForm;
